import { Const } from '../lib/const.cls'

export const getters = {
	[Const.GET_DIGI_ERROR]: (state) => {										
		return state.digio_error
	},
	[Const.GET_DIGIO_RESPONSE]: (state) => {										
		return state.digio_data || {}
	},
	[Const.GET_DOCUMENT_URL_DEL]: (state) => {										
		return state.doc_url_DEL
	},

	[Const.GET_CONTRACT_NOTE_DOCUMENT_URL_DEL]: (state) => {										
		return state.contract_note_document_url_DEL
	},

	[Const.GET_FINANCIAL_LEDGER_LIST1]: (state) => {										
		return state.financial_ledger_list1
	},

	[Const.GET_TAX_REPORT_LIST1]: (state) => {										
		return state.tax_report
	},
	//======================================================== tax-report========================================================

	[Const.GET_TAX_REPORT_LIST]: (state) => {										
		return state.tax_report_list
	},

	[Const.GET_KSOFT_TAX_REPORT_LIST]: (state) => {									
		return state.ksoft_tax_report_list
	},

	[Const.GET_KSOFT_PROFILE_API]: (state) => {									
		return state.ksoftProfileData
	},

	[Const.GET_MARGIN_PLEDGE_SUCCESS_ISIN]: (state) => {									
		return state.marginPledgeSuccessIsin
	},

	[Const.GET_BANK_INFORMATION_IN_DETAIL]: (state) => {									
		return state.bankInformationInDetail
	},


	//------------------------------------------------------------listing----------------------------------------------------------
	[Const.GET_PLEDGE_APPROVED_ISINS]: (state) => {											// profile page
		return state.pledge_approved_isin
	},

	[Const.GET_MF_CHART_DATA]: (state) => {											// profile page
		return state.mf_chart_data
	},
	[Const.GET_NOMINEE_ADD]: (state) => {		
	//console.log('getter',state.nomineeAddJson)								// profile page
		return state.nomineeAddJson
	},
	[Const.GET_CATEGORIZATION_DATA_THROUGH_TICKET]: (state) => {											// profile page
		return state.categorization_data_through_ticket
	},
	[Const.GET_XML_DOC_URL]: (state) => {											// profile page
		return state.xml_doc_url
	},
	[Const.GET_PROFILE_LIST]: (state) => {											// profile page
		return state.profile_list
	},
	[Const.GET_MARGIN_LIST]: (state) => {											// dashboard page
		return state.margin_info_list
	},
	[Const.GET_FINANCIAL_LEDGER_LIST]: (state) => {									// financial ledger page
		return state.financial_ledger_list
	},
	[Const.GET_POSITION_HOLDING_ORDER_LIST]: (state) => {							// position or dashboard page
		return state.position_holding_order_list
	},
	[Const.GET_POSITION_KSOFT_HOLDING_ORDER_LIST]: (state) => {							// position or dashboard page
		return state.position_ksoft_holding_order_list
	},
	[Const.GET_CLOSE_POSITION_LIST]: (state) => {									// position page
		return state.close_position_list
	},
	[Const.GET_TRADE_CONFIRMATION_LIST]: (state) => {								// trade confirm page
		return state.trade_confirmation_list
	},
	[Const.GET_CURRENT_LEVERAGE]: (state) => {										// trade confirm page
		return state.current_leverage
	},
	[Const.GET_REASON_TICKET]: (state) => {											// reason wise open ticket
		return state.reason_open_ticket
	},	
	
	[Const.GET_CONTRACT_NOTE_LIST]: (state) => {									// contract note page
		return state.contract_note_list
	},
	[Const.GET_DEPOSIT_LIST]: (state) => {											// deposit page
		return state.deposit_list
	},
	[Const.GET_SUPPORT_LIST]: (state) => {											// support page
		return state.support_list
	},
	[Const.GET_PCR_DATA]: (state) => {											
		return state.pcr_list
	},
	[Const.GET_CATEGORIZATION_DATA]: (state) => {											
		return state.categorization_list
	},
	//------------------------------------------------------------view------------------------------------------------------------
	[Const.GET_SUPPORT_VIEW]: (state) => {											//support view page
		return state.support_view
	},
	[Const.GET_COMPLAINT_OTP_VIEW_DATA]: (state) => {								// otp send
		return state.complaint_otp_view_data
	},
	//------------------------------------------------------------dropdown--------------------------------------------------------
	[Const.GET_SUPPORT_REASON_LIST]: (state) => {
		return state.support_reason_list
	},
	[Const.GET_PLATFORM_LIST]: (state) => {
		return state.platform_list
	},
	[Const.GET_BANK_LIST]: (state) => {
		return state.bank_list
	},
	[Const.GET_ACCOUNT_TYPE_LIST]: (state) => {
		return state.account_type_list
	},
	[Const.GET_RESIDENT_LIST]: (state) => {
		return state.resident_list
	},
	[Const.GET_GENDER_LIST]: (state) => {
		return state.gender_list
	},
	[Const.GET_CITY_LIST]: (state) => {
		return state.city_list
	},
	[Const.GET_STATE_LIST]: (state) => {
		return state.state_list
	},
	[Const.GET_COUNTRY_LIST]: (state) => {
		return state.country_list
	},
	[Const.GET_FATCA_COUNTRY_LIST]: (state) => {
		return state.fatca_country_list
	},
	[Const.GET_NATIONALITY_LIST]: (state) => {
		return state.nationality_list
	},
	[Const.GET_MARTIAL_STATUS_LIST]: (state) => {
		return state.matrial_status_list
	},
	[Const.GET_SEGMENT_LIST]: (state) => {
		return state.segment_list
	},
	[Const.GET_ADDRESS_TYPE_LIST]: (state) => {
	return state.address_type_list
	},
	[Const.GET_EXCHANGE_LIST]: (state) => {
		return state.exchange_list
	},
	[Const.GET_ADDRESS_PROOF_LIST]: (state) => {
	return state.address_proof_list
	},
	[Const.GET_ADDRESS_CHANGE_LIST]: (state) => {
	return state.address_change_list
	},
	[Const.GET_OCCUPATION_LIST]: (state) => {
	return state.occupation_list
	},
	[Const.GET_INCOME_LIST]: (state) => {
	return state.income_list
	},
	[Const.GET_GROSS_ANNUAL_INCOME_LIST]: (state) => {
	return state.gross_annual_income_list
	},
	[Const.GET_TRADE_EXPERIENCE_LIST]: (state) => {
	return state.trade_experience_list
	},
	[Const.GET_HOLD_REASON_LIST]: (state) => {
	return state.hold_reason_list
	},
	[Const.GET_KRA_ADDRESS_PROOF_LIST]: (state) => {
	return state.kra_address_proof_list
	},
	//------------------------------------------------------------document url-----------------------------------------------------
	[Const.GET_CONTRACT_NOTE_DOCUMENT_URL]: (state) => {
		return state.contract_note_document_url
	},
	[Const.GET_ESIGN_ADHAR_DOCUMENT_URL]: (state) => {
		return state.esign_adhar_doc_url
	},
	[Const.GET_ESIGN_ADHAR_DOCUMENT_URL_USER]: (state) => {
		return state.esign_adhar_doc_url_user
	},
	[Const.GET_VIEW_TICKET_DOCUMENT_URL]: (state) => {
		return state.view_ticket_doc_url
	},
	[Const.GET_TAX_REPORT_DOWNLOAD_DOCUMENT_URL]: (state) => {
		return state.tax_report_download_doc_url
	},
	[Const.GET_VIEW_TICKET_EMAIL_MOBILE_DOC_URL]: (state) => {
		return state.view_ticket_email_mobile_doc_url
	},
	//----------------------------------------------------------leverage json-------------------------------------------------------
	[Const.GET_LEVERAGE_JSON]: (state) => {
		return state.leverage_list
	},

	[Const.GET_SCRATCH_COUPON]: (state) => {
		return state.scratch_coupon
	},



	[Const.GET_PORTFOLIO_LIST_DATA]: (state) => {
		return state.portfolio_list
	},

	[Const.GET_PORTFOLIO_LIST_DATA_AMOUNT]: (state) => {
		return state.portfolio_list_amount
	},

	[Const.GET_CATALOG_PRODUCT_LIST]: (state) => {
		return state.catalog_product_list
	},
	[Const.GET_CHECK_BALANCE]: (state) => {
		return state.check_balance
	},
	[Const.GET_ORDER_HISTORY_LIST]: (state) => {
		return state.order_history
	},

	//===========referral coupon================

	[Const.GET_COUPONS_LIST]: (state) => {
		return state.CouponsList
	},
	[Const.GET_BALANCE_AMOUNT]: (state) => {
		return state.balance
	},
	[Const.GET_COUPON_ORDER_HISTORY_LIST]: (state) => {
		return state.CouponOrderList
	},


	[Const.GET_COUPON_CART_LIST]: (state) => {
		return state.Cartlist
	},
	[Const.GET_PENDING_BALANCE]: (state) => {
		return state.pendingBalance
	},

	//============nominee data=================
	[Const.GET_CLIENT_NOMINEE_DATA]: (state) => {
		return state.nomineeList
	},
}



// WEBPACK FOOTER //
// ./src/plugins/prism/provider/candle-history/store-addons/getters.js